import React from 'react';
import { useAppSelector } from '../../app/hooks';
import { selectFeatureFlagHitl3 } from '../../redux/features/config/config.selector';
import { selectAITurn } from '../../redux/features/ai/ai.selector';
import { selectAIIndicator } from '../../selectors/restaurant';
import { selectSessionId } from '../../redux/features/sessionBoundary/sessionBoundary.selectors';
import PulseMeterTile from './PulseMeterTile';

/**
 * TURN (HITL 3.0 Pulse tile).
 *
 * The conversation turn count from the latest `ai_session_state` event
 * (`data.turn`). Rendered like Menu Board Time — a big numeral + label — but as
 * a plain counter: there is no threshold, so no progress bar and no colour band.
 *
 *   • Default / idle   → 0.
 *   • Session state     → shows the latest `turn`.
 *   • New order         → resets to 0 (ai slice reset).
 *
 * Shown only during an active session (valid session id) AND only when AI is
 * enabled (supervised or unsupervised) — a turn count is an AI concept, so it is
 * hidden in pure HITL mode. Gated overall by hitl_3_0.
 */
const formatTurn = (turn: number): string => `${Math.max(0, Math.floor(turn))}`;

const TurnTile = () => {
  const isHitl3 = useAppSelector(selectFeatureFlagHitl3);
  const turn = useAppSelector(selectAITurn);
  const aiEnabled = useAppSelector(selectAIIndicator);
  const sessionId = useAppSelector(selectSessionId);

  if (!isHitl3 || !sessionId || !aiEnabled) {
    return null;
  }

  return (
    <PulseMeterTile
      label="Turn"
      elapsedMs={turn}
      limitMs={0}
      formatValue={formatTurn}
      showProgress={false}
      testId="turn-tile"
    />
  );
};

export default TurnTile;
